import type * as React from 'react';
import { get } from '@Domain/Api';
import beneficiaryTypeGrantsFetched, {
	type BeneficiaryTypeGrantsFetchedAction,
	type BeneficiaryTypeGrantsPayload,
} from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsFetched';
import beneficiaryTypeGrantsFetchFailed, {
	type BeneficiaryTypeGrantsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsFetchFailed';
import type FetchBeneficiaryTypeGrants from '@Application/SubjectTypeDefinitions/Queries/FetchBeneficiaryTypeGrants';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = BeneficiaryTypeGrantsFetchedAction | BeneficiaryTypeGrantsFetchFailedAction;

export default (query: FetchBeneficiaryTypeGrants) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<BeneficiaryTypeGrantsPayload>(
				`${parameters.api.host}/api/accounts/${query.accountId}/beneficiary-type-grants`,
			);

			const action = beneficiaryTypeGrantsFetched(payload, query.accountId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = beneficiaryTypeGrantsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
